import React from 'react'
import styled from 'styled-components'
import { services } from '../utils/constants'

const Services = () => {
  return (<Wrapper>
       <div className='section-center'>
             <article className='header'>
                  <h3>Quality Products <br></br>just for you</h3>
                  <p><strong>Call Us On:</strong> +256775 174647/+256751 602916 <br></br> <strong>Email Us At:</strong> info@benardawuko.com</p>
               
             </article>
             <div className='services-center'>
              {services.map(({id, icon, title, text})=>{
                return <article key={id} className="service">
                             <span className='icon'>{icon}</span>
                             <h4>{title}</h4>
                             <p>{text}</p>
                        

                        </article>


              })

              }
              
              
            </div>

       </div>

       </Wrapper>
)
}

const Wrapper = styled.section`
  h3,
  h4 {
    color: var(--clr-primary-1);
    color:rgb(237, 182, 72);
  }

  padding: 5rem 0;

  background: var(--clr-primary-10);
  background:rgb(246, 228, 243);

  .header h3 {
    margin-bottom: 2rem;
  }

  h3{
    line-height:2.3rem;
  }
  p {
    margin-bottom: 0;
    line-height: 1.8;
    color: var(--clr-primary-3);
    font-size:1.2rem;
    color:rgb(138, 12, 126);
  }
  .services-center {
    margin-top: 4rem;
    display: grid;
    gap: 2.5rem;
   
  }
  .service {
    background: var(--clr-primary-7);
    background:rgb(138, 12, 126);
    text-align: center;
    padding: 2.5rem 2rem;
    border-radius: var(--radius);
    transition:0.5s;
    p {
      color: white;
      transition:0.5s;
    }
  }

  .service:hover{
    box-shadow:0 0 0.5rem rgb(107, 79, 104);
    background-color:white;
  }

  .service:hover p{
    color:rgb(138, 12, 126);
  }
  span {
    width: 4rem;
    height: 4rem;
    display: grid;
    margin: 0 auto;
    place-items: center;
    margin-bottom: 1rem;
    border-radius: 50%;
    background: var(--clr-primary-10);
    color: var(--clr-primary-1);
    svg {
      font-size: 2rem;
    }
  }
  @media (min-width: 992px) {
    .header {
      /* display: grid; */
      display:flex;
      /* grid-template-columns: 1fr 1fr;
      background-color:blue; */
      justify-content:space-between;
    }
  }
  @media (min-width: 576px) {
    .services-center {
      grid-template-columns: repeat(auto-fit, minmax(360px, 1fr))
    }
  }
  @media (min-width: 1280px) {
    padding: 0;
    .section-center {
      transform: translateY(5rem);
    }
  }
`
export default Services
